import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import Charts from '../../components/Charts';
import { Cards } from '../../components';
import TableStatistics from '../../components/List/TableStatistics';
import TableCardMercados from '../../components/List/TableCardMarket';
import useGetFreightStatistics, { GetFreightStatisticQueryResult } from '../../hooks/freights/useGetFreightStatistics';
import TableCardDrivers from '../../components/List/TableCardDrivers';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  flexGrid: {
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    flexGrow: 1,
  },
}));

const Dashboard: React.FC = () => {
  const classes = useStyles();
  const { execute: getFreightStatistics, loading } = useGetFreightStatistics();
  const [freightStatistics, setfreightStatistics] = useState<GetFreightStatisticQueryResult | null>(null);

  useEffect(() => {
    const fetchDataFreightStatistics = async () => {
      const data = await getFreightStatistics();
      setfreightStatistics(data || null);
    };
    fetchDataFreightStatistics();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
          <Charts data={freightStatistics?.freightPercentageOverTime || []} dataFreights={freightStatistics?.freightPercentageAllTime}/>
      </Grid>
      <Grid item xs={12}>
        <Cards data={freightStatistics?.deliveryTotals} loading={loading} />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.flexGrid}>
        <TableCardDrivers />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.flexGrid}>
        <TableCardMercados data={freightStatistics?.worstPdvs || []} loading={loading} />
      </Grid>
      <Grid item xs={12}>
        <TableStatistics data={freightStatistics?.pdvDeliveryTimes || []} loading={loading} />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
